import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import api from '@/utils/api';
import { CashbackInfoResponse } from '@/types/api/mypage/cashbackInfo';

/** キャッシュバック情報取得APIのURL */
const url = ApiUrl.Read.CASHBACK_INFO;

/**
 * キャッシュバック情報取得APIの呼び出しフック。
 * 申請状況や受け取り条件の表示に必要な情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetCashbackInfo = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<CashbackInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetCashbackInfo;
